import { tv, type VariantProps } from 'tailwind-variants';
export type AtHeaderVariants = VariantProps<typeof atHeaderVariants>;

const atHeaderVariants = tv({
  base: 'text-skin-primary',
  slots: {},
  variants: {
    size: {
      h1: 'h1-lg',
      h2: 'h2-lg',
      h3: 'h3-lg',
      h4: 'h4-lg',
      h5: 'h5-lg',
      h6: 'h6-lg',
      span: 'paragraph-lg',
      p: 'paragraph-lg',
    },
    alt: {
      true: '',
      false: '',
    },
  },
  compoundVariants: [
    {
      size: 'h1',
      alt: true,
      className: 'h1-alt',
    },
    {
      size: 'h2',
      alt: true,
      className: 'h2-alt',
    },
    {
      size: 'h3',
      alt: true,
      className: 'h3-alt',
    },
    {
      size: 'h4',
      alt: true,
      className: 'h4-alt',
    },
  ],
});

export default atHeaderVariants;
